import { Select } from 'antd';
import { useModels } from '@modules/models';

export const TransactionsTableModelNameFilter = ({ column: { filterValue, setFilter } }) => {
  const { data, isLoading } = useModels();

  return (
    <Select loading={isLoading} allowClear={true} style={{ width: '100%' }} onChange={setFilter} value={filterValue}>
      {data?.map((status) => (
        <Select.Option key={status.id} value={status.id.toString()}>
          {status.name}
        </Select.Option>
      ))}
    </Select>
  );
};
